import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';

interface UIState {
  // 移动端状态
  showMobilePanel: 'list' | 'content';
  mobileBottomNavTab: 'home' | 'companies' | 'industries';
  lastActiveTab: 'home' | 'companies' | 'industries';
  savedScrollPositions: Record<string, number>;
  mobileViewMode: 'navigation' | 'content';
  
  // 弹窗状态
  showAuthModal: boolean;
  showPWAPrompt: boolean;
  isPWAInstalled: boolean;
  
  // Actions
  setShowMobilePanel: (panel: 'list' | 'content') => void;
  setMobileBottomNavTab: (tab: 'home' | 'companies' | 'industries') => void;
  setLastActiveTab: (tab: 'home' | 'companies' | 'industries') => void;
  saveScrollPosition: (tabKey: string, position: number) => void;
  setMobileViewMode: (mode: 'navigation' | 'content') => void;
  setShowAuthModal: (show: boolean) => void;
  setShowPWAPrompt: (show: boolean) => void;
  setIsPWAInstalled: (installed: boolean) => void;
  
  // 复合操作
  switchToContent: (tab: 'home' | 'companies' | 'industries') => void;
  switchToNavigation: (tab: 'home' | 'companies' | 'industries') => void;
}

export const useUIStore = create<UIState>()(
  subscribeWithSelector((set) => ({
    // Initial state
    showMobilePanel: 'list',
    mobileBottomNavTab: 'home',
    lastActiveTab: 'home',
    savedScrollPositions: {},
    mobileViewMode: 'navigation',
    showAuthModal: false,
    showPWAPrompt: false,
    isPWAInstalled: false,
    
    // Simple setters
    setShowMobilePanel: (panel) => set({ showMobilePanel: panel }),
    setMobileBottomNavTab: (tab) => set({ mobileBottomNavTab: tab }),
    setLastActiveTab: (tab) => set({ lastActiveTab: tab }),
    saveScrollPosition: (tabKey, position) => set((state) => ({
      savedScrollPositions: {
        ...state.savedScrollPositions,
        [tabKey]: position,
      },
    })),
    setMobileViewMode: (mode) => set({ mobileViewMode: mode }),
    setShowAuthModal: (show) => set({ showAuthModal: show }),
    setShowPWAPrompt: (show) => set({ showPWAPrompt: show }),
    setIsPWAInstalled: (installed) => set({ isPWAInstalled: installed }),
    
    // 复合操作
    switchToContent: () => set((state) => {
      // 保存当前滚动位置
      const scrollY = window.scrollY;
      return {
        lastActiveTab: state.mobileBottomNavTab,
        showMobilePanel: 'content',
        mobileViewMode: 'content',
        savedScrollPositions: {
          ...state.savedScrollPositions,
          [state.mobileBottomNavTab]: scrollY,
        },
      };
    }),
    
    switchToNavigation: (tab) => set({
      mobileBottomNavTab: tab,
      lastActiveTab: tab,
      mobileViewMode: 'navigation',
      showMobilePanel: 'list',
    }),
  }))
);